import { render, staticRenderFns } from "./PayModal.vue?vue&type=template&id=2471abad&scoped=true"
import script from "./PayModal.vue?vue&type=script&lang=js"
export * from "./PayModal.vue?vue&type=script&lang=js"
import style0 from "./PayModal.vue?vue&type=style&index=0&id=2471abad&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471abad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2471abad')) {
      api.createRecord('2471abad', component.options)
    } else {
      api.reload('2471abad', component.options)
    }
    module.hot.accept("./PayModal.vue?vue&type=template&id=2471abad&scoped=true", function () {
      api.rerender('2471abad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seal/PayModal.vue"
export default component.exports